<template>
  <div class="my-bag">
    <h1>My Bag</h1>
    <ModalForm />
  </div>
</template>

<script>
import ModalForm from '@/components/ui/ModalForm.vue'

export default {
  components: {
    ModalForm
  }
}
</script>
